<template>
    <div class="lesson-box">
        <el-row>
            <OldPeriodList
                :good-list="info.oldPeriodList"
                :is-sort="false">
            </OldPeriodList>
        </el-row>
<!--        <el-row class="last-class-img"></el-row>-->
        <!--        <el-image :src="url"></el-image>-->
        <!--        <div class="last-img"></div>-->
    </div>

</template>
<script>
    import {queryOldPeriodList} from "@api/lesson";
    import {formatDate} from "@api/date.js";
    import OldPeriodList from "@components/OldPeriodList";

    export default {
        name: "OldClassChannelList",
        components: {OldPeriodList},
        props: {
            goodList: {
                type: Array,
                default: () => []
            },
            isSort: {
                type: Boolean,
                default: true
            }
        },
        data: function () {
            return {
                url: '@assets/images/classChannel/3.jpg',
                info: {oldPeriodList: []}
            };
        },
        mounted(){
            this.getOldPeriodList()
            /**
             * iframe-宽高自适应显示
             */
            function changeMapIframe(){
                const map = document.getElementById('map');
                const deviceWidth = document.body.clientWidth;
                const deviceHeight = document.body.clientHeight;
                map.style.width = Number(deviceWidth) + 'px'; //数字是页面布局宽度差值
                map.style.height = Number(deviceHeight)+ 'px'; //数字是页面布局高度差
            }

            changeMapIframe()
            window.onresize = function(){
                changeMapIframe()
            }
        },
        methods: {
            getOldPeriodList() {
                var params = {
                    state: 1
                };
                queryOldPeriodList(params).then(res => {
                    // console.log(res.oldPeriodList);
                    this.info.oldPeriodList = res.oldPeriodList;
                })
            }
        },
        filters: {
            formatDateDay(time) {
                var date = new Date(time);
                return formatDate(date, "yyyy-MM-dd");
            }
        }
    };
</script>

<style>
    .lesson-text-line1 {
        text-align: left;
        margin-top: 1vh;
        font-size: 12px;
        margin-left: 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .lesson-box {
        /*margin-left: 0vw;*/
        /*margin-right: 0vw;*/
        /*margin-top: 1vh;*/
        /*padding: 1px;*/
        margin: 0px;
    }

    .lesson-img {
        margin-top: 1vh;
        margin-left: 1px;
        width: 100%;
        border-radius: 5px;
    }

    .el-row-out {
        /*height: 16.5vh;*/
        margin: 1vh;
        /*border:2px solid white;*/
        border-radius: 8px;
        padding: 1vw;
    }

    .el-row-in {
        margin-bottom: 5vh;
    }

    .lesson-tag {
        margin-left: 1vw;
        width: 90%;
        border-radius: 30px;
    }

    .last-class-img {
        height: 20vh;
        width: 100%;
        position: relative;
        text-align: center;
        background-size: 100% 100%; /*按比例缩放*/
        background-image: url("../assets/images/classChannel/3.jpg");
    }
</style>
